import { render, staticRenderFns } from "./UptimeTable.vue?vue&type=template&id=75204eae&"
import script from "./UptimeTable.vue?vue&type=script&lang=js&"
export * from "./UptimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports